import { render, staticRenderFns } from "./mypush.vue?vue&type=template&id=d9e67d96&scoped=true&"
import script from "./mypush.vue?vue&type=script&lang=js&"
export * from "./mypush.vue?vue&type=script&lang=js&"
import style0 from "./mypush.vue?vue&type=style&index=0&id=d9e67d96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9e67d96",
  null
  
)

export default component.exports